export const BRAND_LOGO_SRC = "/images/logo.svg?v=20260817-clean-wordmark";

export function BrandLogo({ alt = "", className }: { alt?: string; className?: string }) {
  return (
    <img
      className={className}
      src={BRAND_LOGO_SRC}
      alt={alt}
      width="900"
      height="200"
      draggable={false}
    />
  );
}
